export const getUserData = () => {
    try {
        const role=new Object(JSON.parse(sessionStorage.getItem('user_data'))).role;
        return role;   
    } catch (error) {
        alert("ошибка при получении данных о пользователе. Данные отсутсвуют. Необходимо перезайти в систему.")
    }
} 